import { gql } from "@apollo/client";

export default gql`
  query  getWorkerDCTrancation($dcCustomerNumber: String!) {
    getWorkerDCTrancation (dcCustomerNumber: $dcCustomerNumber)
  }
`;
